// extracted by mini-css-extract-plugin
export var background = "style-module--background--1dc08";
export var modal = "style-module--modal--0fb65";